import "./ContactCard.css";
import phoneIcon from "../../Assets/Images/phone_icon.png";
import mailIcon from "../../Assets/Images/mail_icon.png";
import editIcon from "../../Assets/Images/edit-button-icon.png";
import deleteIcon from "../../Assets/Images/delete-button-icon.png";
import jobIcon from "../../Assets/Images/jobTypeIcon.png";
import locationIcon from "../../Assets/Images/location_icon.png";
import eyeLightIcon from "../../Assets/Images/eye-open-dark-icon.png";
import CustomTooltip from "../Tooltip/Tooltip";
const ContactCard = ({
  contacts,
  onEditContact,
  onViewContact,
  onDeleteContact,
  backgroundColor = "#6e6deb",
}) => {
  return (
    <div className="contacts-container">
      <div className="contacts-grid">
        {contacts.map((contact, index) => (
          <ContactCardContanier
            key={contact.id || `contact-${index}`}
            contact={contact}
            onEdit={onEditContact}
            onView={onViewContact}
            onDelete={onDeleteContact}
            backgroundColor={backgroundColor}
          />
        ))}
      </div>
    </div>
  );
};

const ContactCardContanier = ({
  contact,
  onEdit,
  onView,
  onDelete,
  backgroundColor,
}) => {
  return (
    <div className="contact-card">
      <div className="contact-header" style={{ background: backgroundColor }}>
        <h4 className="contact-name">{contact.name || "N/A"}</h4>
        <div className="contact-actions">
          <CustomTooltip title="View Contact" arrow>
            <button
              className="contact-action-btn"
              onClick={() => onView(contact)}
            >
              <img
                alt="view"
                src={eyeLightIcon}
                style={{ width: "16px", height: "16px" }}
              />
            </button>
          </CustomTooltip>

          <CustomTooltip title="Edit Contact" arrow>
            <button
              className="contact-action-btn"
              onClick={() => onEdit(contact)}
            >
              <img
                alt="edit"
                src={editIcon}
                style={{ width: "16px", height: "16px" }}
              />
            </button>
          </CustomTooltip>

          <CustomTooltip title="Delete Contact" arrow>
            <button
              className="contact-action-btn"
              onClick={() => onDelete(contact)}
            >
              <img
                alt="delete"
                src={deleteIcon}
                style={{ width: "16px", height: "16px" }}
              />
            </button>
          </CustomTooltip>
        </div>
      </div>
      <div className="contact-details">
        <div className="contact-detail-checkbox">
          <img
            alt="mailIcon"
            src={mailIcon}
            style={{ width: "20px", height: "20px" }}
          />
          <span className="checkbox-label">{contact.email || "N/A"}</span>
        </div>
        <div className="contact-detail-checkbox">
          <img
            alt="phoneIcon"
            src={phoneIcon}
            style={{ width: "20px", height: "20px" }}
          />
          <span className="checkbox-label">{contact.phone || "N/A"}</span>
        </div>
        <div className="contact-detail-checkbox">
          <img
            alt="designationIcon"
            src={jobIcon}
            style={{ width: "20px", height: "20px" }}
          />
          <span className="checkbox-label">{contact.designation || "N/A"}</span>
        </div>
        <div className="contact-detail-checkbox">
          <img
            alt="designationIcon"
            src={locationIcon}
            style={{ width: "20px", height: "20px" }}
          />
          <span className="checkbox-label">{contact.location || "N/A"}</span>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
